import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  jsonLd?: object;
  ogImage?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, canonical, jsonLd, ogImage }) => {
  const siteUrl = 'https://jackpotquantum.com';
  const fullTitle = title.includes('|') ? title : `${title} | JackpotQuantum.com`;
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={fullCanonical} />
        
        {/* Open Graph */}
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={fullCanonical} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="JackpotQuantum.com" />
        {ogImage && <meta property="og:image" content={`${siteUrl}${ogImage}`} />}
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
        {ogImage && <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />}
      </Helmet>
      
      {jsonLd && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
        </Helmet>
      )}
    </>
  );
};

export default SEO;

